import {IApiMatchResult, IApiParticipant} from "../typings/apiResponse";
import {Model} from "./Model";

export class MatchResult extends Model {
    private participants: Array<Participant>;

    constructor(private apiData: IApiMatchResult) {
        super(apiData);

        this.participants = [];
        this.participants.push(new Participant(this.apiData.participants[0]));
        this.participants.push(new Participant(this.apiData.participants[1]));
    }

    public getId(): number {
        return this.apiData.id;
    }

    public getState(): string {
        return this.apiData.state;
    }

    public getBracket(): number {
        return this.apiData.bracket;
    }

    public getRound(): number {
        return this.apiData.round;
    }

    public getPosition(): number {
        return this.apiData.position;
    }

    public getParticipants(): Array<Participant> {
        return this.participants;
    }
}

export class Participant {
    constructor(private apiData: IApiParticipant) {
    }

    public getId(): number {
        return this.apiData.id;
    }

    public getPlace(): number {
        return this.apiData.place;
    }

    public getPoints(): Array<number> {
        return this.apiData.points;
    }
}
